import { render } from "./sidebar.vue?vue&type=template&id=5c5d4891&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=5c5d4891&lang=css"
import "./sidebar.vue?vue&type=style&index=1&id=5c5d4891&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5d4891"]])

export default __exports__